// ==============================|| OVERRIDES - TIMELINE DOT ||============================== //

export default function TimelineDot() {
  return {
    MuiTimelineDot: {
      styleOverrides: {
        root: {
          boxShadow: 'none'
        }
      }
    }
  };
}
